/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:app_group_id/deactivate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesAppGroupIdDeactivateCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesAppGroupIdDeactivateProps,
  PostApiCalculatedAttributesAppGroupIdDeactivateResult,
} from "./types";

// POST rather than the PATCH calculated filters uses -- see routes.rb.
export const postApiCalculatedAttributesAppGroupIdDeactivate = reactQueryMutationAdapter(
  postApiCalculatedAttributesAppGroupIdDeactivateCacheKeys,
  (
    props: PostApiCalculatedAttributesAppGroupIdDeactivateProps
  ): Promise<PostApiCalculatedAttributesAppGroupIdDeactivateResult> => {
    const { app_group_id: appGroupId, calculated_attribute_ids: calculatedAttributeIds } = props;
    return fetch(
      `/api/calculated_attributes/${appGroupId}/deactivate`,
      "POST",
      { calculated_attribute_ids: calculatedAttributeIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
